/**
 * Regex Rules
 */
// at least one number, one lowercase and one uppercase letter
export const REGEX_PASSWORD = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{7,}/;

// at least seven characters
export const REGEX_PASSWORD_LENGTH = /^[a-zA-Z0-9]{7,}/;
export const REGEX_PASSWORD_LOWERCASE = /[a-z]/;
export const REGEX_PASSWORD_UPPERCASE = /[A-Z]/;
export const REGEX_PASSWORD_NUMBER = /\d/;

export const REGEX_ZIPCODE = /\d{5}/;

export const REGEX_IDENTIFICATIONID = /^\d{3}-?\d{2}-?\d{4}$|^[A-Z][12]\d{8}$/;

// Should handle names like Yat-sen O'Neil, Jr. and have a length limit
export const REGEX_NAME = /^[\u4e00-\u9fa5a-zA-Z][\u4e00-\u9fa5a-zA-Z\s'',-]*$/i;
export const REGEX_PHONE = /^[\d()-]{1,32}$/;

/**
 * disable next line to bypass max-len
 * http://eslint.org/docs/rules/max-len
 */
// eslint-disable-next-line
export const REGEX_EMAIL = /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;



// WEBPACK FOOTER //
// ./src/toolbox/regex.js